import React,{useEffect} from 'react';
import ContactForm from '../components/contactForm';
import '../styles/contactUs.css';

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="contactus-main">
      <div className="header-section">
      <h2>Contact Us</h2>
        <div className="after-line-contact"></div>
      </div>
      <ContactForm />
    </div>
  );
};

export default ContactUs;
